import { X } from 'lucide-react';
import { type ReactNode, useEffect, useRef } from 'react';

interface Props {
  aberto: boolean;
  titulo: string;
  descricao?: string;
  aoFechar: () => void;
  children: ReactNode;
  largura?: string;
}

/** Diálogo modal sobre o <dialog> nativo: foco preso, Esc fecha, foco volta ao botão de origem. */
export function Dialogo({ aberto, titulo, descricao, aoFechar, children, largura = 'max-w-lg' }: Props) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialogo = ref.current;
    if (!dialogo) return;
    if (aberto && !dialogo.open) dialogo.showModal();
    if (!aberto && dialogo.open) dialogo.close();
  }, [aberto]);

  return (
    <dialog
      ref={ref}
      onCancel={(e) => {
        e.preventDefault();
        aoFechar();
      }}
      aria-labelledby="dialogo-titulo"
      className={`m-auto w-[calc(100%-2rem)] ${largura} rounded-painel border border-linha bg-superficie p-0 text-tinta shadow-xl backdrop:bg-tinta/40`}
    >
      {aberto && (
        <div className="flex max-h-[85vh] flex-col">
          <header className="flex items-start justify-between gap-4 border-b border-linha-suave px-5 py-4">
            <div>
              <h2 id="dialogo-titulo" className="text-[15px] leading-[22px] font-semibold">
                {titulo}
              </h2>
              {descricao && <p className="mt-0.5 text-tinta-2">{descricao}</p>}
            </div>
            <button
              type="button"
              onClick={aoFechar}
              aria-label="Fechar"
              className="-m-1 cursor-pointer rounded p-1 text-tinta-2 hover:bg-fundo hover:text-tinta"
            >
              <X aria-hidden className="size-5" />
            </button>
          </header>
          <div className="overflow-y-auto px-5 py-4">{children}</div>
        </div>
      )}
    </dialog>
  );
}
